import { AddressDto } from '@/api';

export const _address = {
  street: '',
  streetNumber: '',
  city: '',
  zip: '',
} as AddressDto;
